module.exports = __webpack_public_path__ + "static/media/edit.b3d22df2.svg";